import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import MetaHero from '@/components/meta/MetaHero';
import MetaCaseStudies from '@/components/meta/MetaCaseStudies';
import MetaSystem from '@/components/meta/MetaSystem';
import MetaFaq from '@/components/meta/MetaFaq';
import CalendlySection from '@/components/CalendlySection';
import { FAQS } from '@/data/metaOffer';

const TITLE = 'Stop Bleeding Money on Meta Ads — Scale to $100k/Month Instead | Ahana Digital Agency';
const DESCRIPTION =
  'We identify where your ad spend is bleeding and show you exactly how to scale profitably on Meta. Request your free Meta Ads breakdown from Ahana Digital Agency.';

export default function MetaAds() {
  useEffect(() => {
    document.title = TITLE;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', DESCRIPTION);
    setMeta('property', 'og:title', TITLE);
    setMeta('property', 'og:description', DESCRIPTION);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://www.ahana.digital/meta-ads');

    const ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.id = 'meta-ads-faq-schema';
    ld.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    document.head.appendChild(ld);

    return () => {
      document.getElementById('meta-ads-faq-schema')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <Navbar />
      <main>
        <h1 className="sr-only">
          Stop bleeding money on Meta ads — scale to $100k per month with Ahana Digital Agency
        </h1>
        <MetaHero />
        <MetaCaseStudies />
        <MetaSystem />
        <MetaFaq />
        <CalendlySection />
      </main>
      <Footer />
    </div>
  );
}